module.exports = __webpack_public_path__ + "img/queen_w.4320a2dd.svg";